import { useApi } from '@/api';
import { Link, TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  CryptoIcon,
  CurrencyValue,
  EtherScanPictogram,
  Flex,
  WalletAddress,
  useTableProps,
  DataTable,
  RelativeDateTime
} from '@blockanalitica/ui';

export default function DSREventsTable() {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: '/save/dsr/events/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Wallet Address',
        getCell: (row) => (
          <Link
            to={`/savings/dai-savings-rate/suppliers/${row.wallet_address}`}>
            <WalletAddress
              address={row.wallet_address}
              options={{
                inline: true,
                sizes: { blockie: '0' }
              }}
            />
          </Link>
        )
      },
      {
        header: 'Event',
        getCell: (row) => row.event,
        sortingField: 'event'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Amount
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.amount}
            options={{
              trend: true,
              iconSize: '0'
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'amount'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap="3xs" color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),

        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
